import "./Footer.scss";

function Footer() {
  return (
    <footer>
      {" "}
      <small>&copy; Copyright 2026, Sara Artese</small>{" "}
    </footer>
  );
}

export default Footer;
